import axios from '@dap/shared-utils/http.js';

export default {
    getDictInfo (params = {}) {
        return axios.get('/coach/api/regulation/target', { params });
    },

    getRuleManageList (params = {}) {
        return axios.get('/coach/api/regulation', { params });
    },

    getRuleDetail (params = {}) {
        return axios.get('/coach/api/regulation/edit', { params });
    },

    udpateRuleStatus (params = {}) {
        return axios.get('/coach/api/regulation/status', { params });
    },

    getRecordList (params = {}) {
        return axios.post('/coach/api/regulation/runlog', params);
    },

    deleteRule (params = {}) {
        return axios.get('/coach/api/regulation/delete', { params });
    },

    udpateRule (params = {}) {
        return axios.post('/coach/api/regulation', params);
    },

    getLayerList (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('account', 'ad_accounts');
        typeMap.set('campaign', 'ad_campaigns');
        typeMap.set('group', 'ad_groups');
        typeMap.set('ad', 'ads');
        return axios.post(`/coach/api/regulation/${typeMap.get(type)}`, params);
    },

    getAdvertisesList (menuKey, spreaderAlias, params = {}) {
        return axios.get(`/dapper/api/${spreaderAlias}_ad/${menuKey}/list`, {
            params,
        });
    },

    //新
    getDictInfo2 (params = {}) {
        return axios.get('/dapper/api/rule/dict', { params });
    },
    getRuleManage2List (params = {}) {
        return axios.get('/dapper/api/rule/list', { params });
    },
    getRule2Detail (params = {}) {
        return axios.get('/dapper/api/rule/get', { params });
    },
    applicationRules (params = {}) {
        return axios.post('/dapper/api/rule/target', params);
    },
    udpateRuleStatus2 (params = {}) {
        return axios.post('/dapper/api/rule/action', params);
    },
    saveRuleData (params = {}) {
        return axios.post('/dapper/api/rule/save', params);
    },
    operationRecord (params = {}) {
        return axios.get('/dapper/api/rule/log/list', { params });
    },
    getHierarchyData (params = {}, menuKey = '', platform = '') {
        const typeObj = {
            campaign: 'campaign',
            group: 'adgroup',
            ad: 'ad',
        };

        return axios.get(`/dapper/api/${platform}_ad/${typeObj[menuKey]}/list`, { params });
    },

    // /dapper/api/toutiao_ad/campaign/list
    ///dapper/api/toutiao_ad/adgroup/list
    ///dapper/api/toutiao_ad/ad/list
    ///dapper/api/gdt_ad/campaign/list
    ///dapper/api/gdt_ad/adgroup/list
    ////dapper/api/gdt_ad/ad/list
};
